module.exports = __webpack_public_path__ + "static/img/role003.4e80915.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role003.jpg
// module id = P/v7
// module chunks = 1